import * as ActionsTypes from "../../../common/state/StateConstants";

export const registerMFA = (payload) => {
  return {
    type: ActionsTypes.REGISTER_MFA,
    payload,
  };
};

export const registerMFASuccess = (data) => {
  return {
    type: ActionsTypes.REGISTER_MFA_SUCCESS,
    data,
  };
};

export const registerMFAFailure = (error) => {
  return {
    type: ActionsTypes.REGISTER_MFA_FAILURE,
    error,
  };
};

export const sendOtpMail = (payload) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL,
    payload,
  };
};

export const sendOtpMailSuccess = (data) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL_SUCCESS,
    data,
  };
};

export const sendOtpMailFailure = (error) => {
  return {
    type: ActionsTypes.SEND_OTP_MAIL_FAILURE,
    error,
  };
};

export const searchDemandes = (searchObject, expanded) => {
  return {
    type: ActionsTypes.SEARCH_DEMANDE,
    searchObject,
    expanded,
  };
};

export const searchDemandesSuccess = (data) => {
  return {
    type: ActionsTypes.SEARCH_DEMANDE_SUCCESS,
    data,
  };
};

export const searchDemandesFailure = (error) => {
  return {
    type: ActionsTypes.SEARCH_DEMANDE_FAIL,
    error,
  };
};

export const searchAllDemandes = (searchObject) => {
  return {
    type: ActionsTypes.SEARCH_ALL_DEMANDES,
    searchObject,
  };
};

export const searchAllDemandesSuccess = (data) => {
  return {
    type: ActionsTypes.SEARCH_ALL_DEMANDES_SUCCESS,
    data,
  };
};

export const searchAllDemandesFailure = (error) => {
  return {
    type: ActionsTypes.SEARCH_ALL_DEMANDES_FAILURE,
    error,
  };
};

export const fetchHistorique = (id) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_DFD,
    id,
  };
};

export const fetchHistoriqueSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_DFD_SUCCESS,
    data,
  };
};

export const fetchHistoriqueFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_DFD_FAILURE,
    error,
  };
};

export const clearHistorique = () => {
  return {
    type: ActionsTypes.CLEAR_HISTORIQUE_DFD,
  };
};

export const updateSearchForm = (searchObject) => {
  return {
    type: ActionsTypes.UPDATE_SEARCH_FORM,
    searchObject,
  };
};

export const clearSearchForm = () => {
  return {
    type: ActionsTypes.CLEAR_SEARCH_FORM,
  };
};

export const authenticate = (payload) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER,
    payload,
  };
};

export const authenticateSuccess = (data) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER_SUCCESS,
    data,
  };
};

export const authenticateFailure = (error) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER_FAILURE,
    error,
  };
};

export const setIsAuthenticated = (data) => {
  return {
    type: ActionsTypes.SET_IS_AUTHENTICATED,
    data,
  };
};

export const resetError = () => {
  return {
    type: ActionsTypes.RESET_ERROR,
  };
};

export const getCategories = () => {
  return {
    type: ActionsTypes.FETCH_CATEGORIES,
  };
};

export const getCategoriesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_CATEGORIES_SUCCESS,
    data,
  };
};

export const getCategoriesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_CATEGORIES_FAILURE,
    error,
  };
};

export const getPaysOrigine = () => {
  return {
    type: ActionsTypes.FETCH_PAYS_ORIGINE,
  };
};

export const getPaysOrigineSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_PAYS_ORIGINE_SUCCESS,
    data,
  };
};

export const getPaysOrigineFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_PAYS_ORIGINE_FAILURE,
    error,
  };
};

export const getEtats = () => {
  return {
    type: ActionsTypes.FETCH_ETATS,
  };
};

export const getEtatsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_ETATS_SUCCESS,
    data,
  };
};

export const getEtatsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_ETATS_FAILURE,
    error,
  };
};

export const getGroupesContingent = () => {
  return {
    type: ActionsTypes.FETCH_GROUPES_CONTINGENT,
  };
};

export const getGroupesContingentSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_GROUPES_CONTINGENT_SUCCESS,
    data,
  };
};

export const getGroupesContingentFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_GROUPES_CONTINGENT_FAILURE,
    error,
  };
};

export const getNomenclatures = (payload) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES,
    payload,
  };
};

export const getNomenclaturesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES_SUCCESS,
    data,
  };
};

export const getNomenclaturesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES_FAILURE,
    error,
  };
};

export const getImportateurs = (payload) => {
  return {
    type: ActionsTypes.FETCH_IMPORTATEURS,
    payload,
  };
};

export const getImportateursSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_IMPORTATEURS_SUCCESS,
    data,
  };
};

export const getImportateursFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_IMPORTATEURS_FAILURE,
    error,
  };
};

export const resetState = () => {
  return {
    type: ActionsTypes.RESET_STATE,
  };
};

export const getDfd = (id) => {
  return {
    type: ActionsTypes.FETCH_DFD,
    id,
  };
};

export const getDfdSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DFD_SUCCESS,
    data,
  };
};

export const getDfdFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DFD_FAILURE,
    error,
  };
};

export const getDfdDecisions = (id) => {
  return {
    type: ActionsTypes.FETCH_DFD_DECISIONS,
    id,
  };
};

export const getDfdDecisionsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DFD_DECISIONS_SUCCESS,
    data,
  };
};

export const getDfdDecisionsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DFD_DECISIONS_FAILURE,
    error,
  };
};

export const getDfdDocuments = (id) => {
  return {
    type: ActionsTypes.FETCH_DFD_DOCUMENTS,
    id,
  };
};

export const getDfdDocumentsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DFD_DOCUMENTS_SUCCESS,
    data,
  };
};

export const getDfdDocumentsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DFD_DOCUMENTS_FAILURE,
    error,
  };
};

export const getDfdMarchandises = (id) => {
  return {
    type: ActionsTypes.FETCH_DFD_MARCHANDISES,
    id,
  };
};

export const getDfdMarchandisesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DFD_MARCHANDISES_SUCCESS,
    data,
  };
};

export const getDfdMarchandisesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DFD_MARCHANDISES_FAILURE,
    error,
  };
};

export const downloadDemande = (id, nom) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND,
    id,
    nom,
  };
};

export const downloadDemandeSuccess = (data) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND_SUCCESS,
    data,
  };
};

export const downloadDemandeFailure = (error) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND_FAILURE,
    error,
  };
};

export const downloadDemandeDocument = (id, nom, action) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT,
    id,
    nom,
    action,
  };
};

export const downloadDemandeDocumentSuccess = (data) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT_SUCCESS,
    data,
  };
};

export const downloadDemandeDocumentFailure = (error) => {
  return {
    type: ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT_FAILURE,
    error,
  };
};

export const getDecisionType = () => {
  return {
    type: ActionsTypes.FETCH_TYPE_DECISION,
  };
};

export const getDecisionTypeSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TYPE_DECISION_SUCCESS,
    data,
  };
};

export const getDecisionTypeFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TYPE_DECISION_FAILURE,
    error,
  };
};

export const getUniteDouniere = () => {
  return {
    type: ActionsTypes.FETCH_TYPE_DOUNIERE,
  };
};

export const getUniteDouniereSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TYPE_DOUNIERE_SUCCESS,
    data,
  };
};

export const getUniteDouniereFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TYPE_DOUNIERE_FAILURE,
    error,
  };
};

export const getUniteComp = () => {
  return {
    type: ActionsTypes.FETCH_UNIT_COMP,
  };
};

export const getUniteCompSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_UNIT_COMP_SUCCESS,
    data,
  };
};

export const getUniteCompFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_UNIT_COMP_FAILURE,
    error,
  };
};

export const getDepartments = () => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS,
  };
};

export const getDepartmentsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS_SUCCESS,
    data,
  };
};

export const getDepartmentsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS_FAILURE,
    error,
  };
};

export const DecisionMceDfd = (startDate, endDate, payload) => {
  return {
    type: ActionsTypes.DECISION_MCE_DFD,
    startDate,
    endDate,
    payload,
  };
};

export const DecisionMceDfdSuccess = (data) => {
  return {
    type: ActionsTypes.DECISION_MCE_DFD_SUCCESS,
    data,
  };
};

export const DecisionMceDfdFailure = (error) => {
  return {
    type: ActionsTypes.DECISION_MCE_DFD_FAILURE,
    error,
  };
};

export const DecisionDepDfd = (payload) => {
  return {
    type: ActionsTypes.DECISION_DEP_DFD,
    payload,
  };
};

export const DecisionDepDfdSuccess = (data) => {
  return {
    type: ActionsTypes.DECISION_DEP_DFD_SUCCESS,
    data,
  };
};

export const DecisionDepDfdFailure = (error) => {
  return {
    type: ActionsTypes.DECISION_DEP_DFD_FAILURE,
    error,
  };
};

export const transferDfd = (payload) => {
  return {
    type: ActionsTypes.TRANSFER_DFD,
    payload,
  };
};

export const transferDfdSuccess = (data) => {
  return {
    type: ActionsTypes.TRANSFER_DFD_SUCCESS,
    data,
  };
};

export const transferDfdFailure = (error) => {
  return {
    type: ActionsTypes.TRANSFER_DFD_FAILURE,
    error,
  };
};

export const getNomenclaturesGroupe = (payload) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES_GROUP,
    payload,
  };
};

export const getNomenclaturesGroupeSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES_GROUP_SUCCESS,
    data,
  };
};

export const getNomenclaturesGroupeFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_NOMENCLATURES_GROUP_FAILURE,
    error,
  };
};

export const getSelectedDepartments = (id) => {
  return {
    type: ActionsTypes.SELECTED_DEPARTMENT,
    id,
  };
};

export const getSelectedDepartmentsSuccess = (data) => {
  return {
    type: ActionsTypes.SELECTED_DEPARTMENT_SUCCESS,
    data,
  };
};

export const getSelectedDepartmentsFailure = (error) => {
  return {
    type: ActionsTypes.SELECTED_DEPARTMENT_FAILURE,
    error,
  };
};

export const getFixedDfdDecision = (id) => {
  return {
    type: ActionsTypes.GET_FIXED_DFD_DECISION,
    id,
  };
};

export const getFixedDfdDecisionSuccess = (data) => {
  return {
    type: ActionsTypes.GET_FIXED_DFD_DECISION_SUCCESS,
    data,
  };
};

export const getFixedDfdDecisionFailure = (error) => {
  return {
    type: ActionsTypes.GET_FIXED_DFD_DECISION_FAILURE,
    error,
  };
};

export const setIsDecisionMode = (data) => {
  return {
    type: ActionsTypes.SET_DECISION_MODE,
    data,
  };
};

export const setIsDecisionVisible = (data) => {
  return {
    type: ActionsTypes.SET_DECISION_VISIBLE,
    data,
  };
};

export const clearDemandeDetails = () => {
  return {
    type: ActionsTypes.CLEAR_DEMANDE_DETIALS,
  };
};

export const setDFDColumnsDensityState = (data) => {
  return {
    type: ActionsTypes.SET_DFD_COLUMNS_DENSITY_STATE,
    data,
  };
};

export const getDFDColumnsDensityState = () => {
  return {
    type: ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE,
  };
};

export const getDFDColumnsDensityStateSuccess = (data) => {
  return {
    type: ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE_SUCCESS,
    data,
  };
};

export const getDFDColumnsDensityStateFailure = (error) => {
  return {
    type: ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE_FAILURE,
    error,
  };
};
export const postChangePassword = (payload) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD,
    payload,
  };
};

export const postChangePasswordSuccess = (data) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD_SUCCESS,
    data,
  };
};

export const postChangePasswordFailure = (error) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD_FAILURE,
    error,
  };
};

export const clearChangePasswordState = () => {
  return {
    type: ActionsTypes.CLEAR_CHANGE_PASSWORD,
  };
};

export const fetchKpiDfd = (year) => {
  return {
    type: ActionsTypes.DFD_KPI,
    year,
  };
};

export const fetchKpiDfdSuccess = (data) => {
  return {
    type: ActionsTypes.DFD_KPI_SUCCESS,
    data,
  };
};

export const fetchKpiDfdFailure = (error) => {
  return {
    type: ActionsTypes.DFD_KPI_FAILURE,
    error,
  };
};

export const setDFDLoading = (data) => {
  return {
    type: ActionsTypes.SET_DFD_LOADING,
    data,
  };
};

export const updateDfdDateFinValidite = (payload) => {
  return {
    type: ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE,
    payload,
  };
};

export const updateDfdDateFinValiditeSuccess = (data) => {
  return {
    type: ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE_SUCCESS,
    data,
  };
};

export const updateDfdDateFinValiditeFailure = (error) => {
  return {
    type: ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE_FAILURE,
    error,
  };
};

export const setDrawerState = (data) => {
  return {
    type: ActionsTypes.SET_DRAWER_STATE,
    data,
  };
};
